/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  app.ServiceOrderStatusView = app.View.extend({
    events: {
      'click .js-download-cert': 'showGotoOrderButton'
    },
    /**
     * Шаблоны
     */
    template: false,
    successTemplate: '#service-order-status-success-template',
    errorTemplate: '#service-order-status-error-template',
    fetchingTemplate: '#service-order-status-fetching-template',

    fetchingTimeout: 1000,
    fetchingMaxSeconds: 30,
    paymentSuccessStatus: 6,
    run: function (options) {
      if (options && options.orderId) {
        this.orderId = options.orderId;
      }
      if (options && options.paymentId) {
        this.paymentId = options.paymentId;
      }

      this.model = new app.Payment({
        id: this.paymentId
      });

      this._setTemplate(this.fetchingTemplate);

      this.listenTo(this.model, 'sync', this.checkPaymentStatus);
      this.listenTo(this.model, 'error', this.showErrorStatus);

      if (!this.order) {
        this._initOrder();
        this.listenTo(this.order, 'sync', this.fetchPaymentStatus);
        this.listenTo(this.order, 'error', this.showErrorStatus);
      }

      /**
       * Через 30 секунд выдать ошибку получения статуса
       */
      var that = this;
      this.throwErrorTimer = setTimeout(function () {
        that.model.trigger('error');
      }, this.fetchingMaxSeconds * 1000);

      this.render();
    },
    /**
     * Инициализация модели заказа
     * @private
     */
    _initOrder: function () {
      this.order = new app.Order({
        id: this.orderId
      });
      this.order.expand = 'expand=email';
      this.order.fetch();
    },
    /**
     * Очистка таймаута
     */
    clearTimer: function () {
      clearTimeout(this.timer);
      clearTimeout(this.throwErrorTimer);
    },
    /**
     * Инициализация шаблона
     * @param templateName
     * @private
     */
    _setTemplate: function (templateName) {
      this.template = app.helpers.TemplateHelper.getTemplate(templateName);
    },
    /**
     * Получение статуса оплаты
     */
    fetchPaymentStatus: function () {
      var that = this;
      this.timer = setTimeout(function() {
        that.model.fetch();
      }, this.fetchingTimeout);
    },
    /**
     * Проверка статуса оплаты
     */
    checkPaymentStatus: function () {
      if (this.model.get('payment_status_id') === this.paymentSuccessStatus) {
        this._setTemplate(this.successTemplate);
        this.clearTimer();
        this.render();
      } else {
        this.fetchPaymentStatus();
      }
    },
    /**
     * Обработка отрицательного ответа (!=200)
     */
    showErrorStatus: function () {
      this._setTemplate(this.errorTemplate);
      clearTimeout(this.timer);
      this.render();
    },
    /**
     * Показать кнопку "Перейти к заказу" на мобильной версии
     * @returns {null}
     */
    showGotoOrderButton: function () {
      if (!app.isMobile) {
        return null;
      }
      var button = this.$('.js-goto-order-page');
      button.removeClass('not_display');
    },
    render: function () {
      this.$el.html(this.template({
        email: this.order.get('email'),
        orderId: this.order.get('id'),
        isMobile: app.isMobile,
      }));
    }
  });
})(jQuery);

}.call(window));